import { Breadcrumb as AntdBreadcrumb } from 'antd';
import React from 'react';
import { AiOutlineExclamationCircle, AiOutlineRight } from 'react-icons/ai';
import { withTheme } from '../ThemeProvider';
import { StyledBreadcrumb, StyledInfoIcon } from './styles';
import type { IBreadcrumbProps } from './types';
import { Link } from 'react-router-dom';

const BreadcrumbComponent: React.FC<IBreadcrumbProps> = ({
    items,
    separator = <AiOutlineRight />,
    ...props
}) => {
    return (
        <StyledBreadcrumb separator={separator} {...props}>
            {items.map((item, index) => {
                const isLast = index === items.length - 1;
                return (
                    <AntdBreadcrumb.Item key={index}>
                        <span
                            className={`breadcrumb-item ${
                                isLast
                                    ? 'breadcrumb-item-last'
                                    : 'breadcrumb-item-link'
                            }`}
                        >
                            {item.href && !isLast ? (
                                <Link
                                    to={item.href}
                                    className="breadcrumb-link"
                                >
                                    {item.label}
                                </Link>
                            ) : (
                                <span>{item.label}</span>
                            )}
                            {item.info && (
                                <StyledInfoIcon>
                                    <AiOutlineExclamationCircle />
                                </StyledInfoIcon>
                            )}
                        </span>
                    </AntdBreadcrumb.Item>
                );
            })}
        </StyledBreadcrumb>
    );
};

export const Breadcrumb = withTheme(BreadcrumbComponent);
